import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

export interface IInlineModalProps {
  'data-qa'?: string;
  children: ReactNode;
  className?: string;
  isVisible: boolean;
}

export const InlineModal = ({
  'data-qa': dataQa,
  children,
  className,
  isVisible,
}: IInlineModalProps) => {
  return (
    isVisible && (
      <InlineModal.Modal data-qa={dataQa} className={className}>
        {children}
      </InlineModal.Modal>
    )
  );
};

InlineModal.Modal = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 272px;
  padding: 16px 16px;
  position: absolute;

  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    color: ${theme.colors.black2};
    z-index: ${theme.zIndex.modal};
    border: 1px solid ${theme.colors.black};
  `}

  @media (min-width: ${({ theme }) => theme.breakpoints.mediumSmall}px) {
    max-width: 418px;
    right: 0;
    top: -20px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mediumSmall - 1}px) {
    left: 0;
    top: 20px;
    right: 0;
    min-width: calc(100vw - 40px);
  }
`;
